import { PRIVACY_LAST_UPDATED, PRIVACY_PREAMBLE, PRIVACY_SECTIONS, PRIVACY_FOOTER } from '../legal/privacy';
import styles from './PrivacyPage.module.css';

const renderParagraphs = (text: string): ReadonlyArray<React.ReactElement> =>
  text.split('\n\n').map((paragraph, idx) => (
    <p key={idx} className={styles.sectionBody}>{paragraph}</p>
  ));

const PrivacyPage = (): React.ReactElement => (
  <div className={styles.container}>
    <h1 className={styles.title}>EVENT.BLACK Privacy Policy</h1>
    <p className={styles.version}>Last Updated: {PRIVACY_LAST_UPDATED}</p>
    {renderParagraphs(PRIVACY_PREAMBLE)}
    {PRIVACY_SECTIONS.map((section) => (
      <section key={section.heading} className={styles.section}>
        <h2 className={styles.sectionHeading}>{section.heading}</h2>
        {renderParagraphs(section.body)}
      </section>
    ))}
    <hr className={styles.divider} />
    {renderParagraphs(PRIVACY_FOOTER)}
  </div>
);

export { PrivacyPage };
